import utils from '../utils';

// TODO
// 1. Responsive events - DONE
// 2. Intersection observer for enable
// 3. distroy function
// 4. Fix ID to avoid duplication - DONE
// 5. correct state diff
// 6. import css through component [IMP]
// 7. Dynamic import of components [IMP]

/**
 * Component super class
 */
class Component {
    constructor(el, id) {
        this.el = el;
        this.$el = $(el);
        this.name = el.dataset.comp;
        this.id = id;
        this.state = this.getInitialState() || {};
        this.previousState = this.state;
        this.url = el.dataset.url;
        this.el.setAttribute('id', this.id);
        this.templateElem = document.getElementById(`tmpl-${this.name}`);
        this.initialize();
        this.watchForChanges();
    }

    /**
     * Initialize the component instance
     */
    initialize() {
        // if template string exist then make a template out of it
        if (this.templateElem) {
            this.template = this.makeTemplate(this.templateElem.innerHTML.replace(/\{/ig, '${').toString());
        }
        // if data definition exists then get data and then render
        if (this.el.dataset.url && typeof this.fetchContent === 'function') {
            this.fetchContent(this.el.dataset.url);
        } else if (this.template) {
            this.render.apply(this, [this.previousState, this.state]);
        } else {
            this.enable.apply(this, [this.previousState, this.state]);
        }

        // check if the browser is been continuesly resized and wait for stop to trigger breakpoint check
        let resizedFinished;
        $('body').on('window:resized', () => {
            clearTimeout(resizedFinished);
            resizedFinished = setTimeout(() => {
                this.breakpointCheck();
                this.onResize();
            }, 100);
        });

        // Post initialization activities
        this.breakpointCheck();
        this.$el.trigger('component:initialized', this);
    }

    /**
     * Get Ajax content reseponse from data-url in component markup
     * @callback RequestCallback
     * @param {string} dataUrl Ajax url
     * @param {RequestCallback} cb - function to call back
     */
    fetchContent(dataUrl, cb) {
        // TODO : need exception handling
        fetch(dataUrl)
            .then((response) => {
                const contentType = response.headers.get('content-type');
                // check if JSON and parse else return text
                if (contentType && contentType.indexOf('application/json') !== -1) {
                    return response.json().then(data => {
                        this.setState({
                            ...this.state,
                            data
                        });
                    });
                }
                return response.text().then(data => {
                    this.setState({
                        ...this.state,
                        data
                    });
                });
            })
            .then(() => {
                if (typeof cb === 'function') {
                    cb();
                }
            });
    }

    /**
     * What for component changes
     */
    watchForChanges() {
        const config = { attributes: true, childList: false, subtree: false };

        try {
            // Callback function to execute when mutations are observed
            // eslint-disable-next-line
            const callback = (mutationList, observer) => {
                for (const mutation of mutationList) {
                    if (mutation.type === 'attributes') {
                        if (mutation.attributeName === 'data-url') {
                            this.fetchContent(this.el.dataset.url);
                        }
                    }
                }
            };

        // Create an observer instance linked to the callback function
            this.observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
            this.observer.observe(this.el, config);
        } catch (error) {
            // Error handling
        }
    }

    /**
     * get Initial component state
     * @returns {Object} - returns empty object
     */
    getInitialState() {
        return {};
    }

    /**
     * Breaktpoint check to call proper handler in component instance
     */
    breakpointCheck() {
        // check if breakpoint changed
        if (this.breaktpoint === utils.getCurrentBreakpoint()) {
            return;
        }

        // update breakpoint
        this.breaktpoint = utils.getCurrentBreakpoint();

        // call corresponding onHandler for breakpoint
        switch (this.breaktpoint) {
            case 'desktop':
            case 'large-desktop':
                this.onDesktop.apply(this);
                break;

            case 'tablet':
                this.onTablet.apply(this);
                break;

            case 'mobile':
                this.onMobile.apply(this);
                break;

            default:
                break;
        }
    }

    /**
     * Get current breakpoint as string
     * @returns {string} - returns breakpoint
     */
    getCurrentBreakpoint() {
        return utils.getCurrentBreakpoint();
    }

    /**
     * Get component definition URL if exists
     * @returns {string} - returns URL
     */
    getUrl() {
        return this.url;
    }

    /**
     * Get component ID
     * @returns {string} - returns component ID
     */
    getComponentId() {
        return this.id;
    }

    // https://gist.github.com/malko/b8a432bbb2198ca5d38cd3dc27d40f24
    makeTemplate(templateString) {
        // eslint-disable-next-line
        return (templateData) => new Function(`{${Object.keys(templateData).join(',')}}`, 'return `' + templateString + '`')(templateData);
    }

    /**
     * Set the component state
     * @param {Object} data Object to set into state
     */
    setState(data) {
        this.state = {
            ...this.state,
            ...data
        };
        if (this.previousState !== this.state) {
            this.previousState = this.state;
            this.render(this.previousState, this.state);
        }
    }

    /**
     * Render component with template if exists
     */
    render() {
        if (this.template) {
            this.el.setHTML(this.template(this.state));
        }

        // once render call enable to do even binding, in case of no render
        // just call enabled to even bind on existing markup
        this.enable.apply(this);
    }

    /**
     * Enable component once initialized
     */
    enable() {
        // implement by child
    }

    disable() {
        this.observer.disconnect();
    }

    /**
     * Mobile handler function which gets called in mobile breakpoint
     */
    onMobile() {
        // implement by child
    }

    /**
     * Tablet handler function which gets calls in tablet breakpoint
     */
    onTablet() {
        // implement by child
    }

    /**
     * Desktop handler function which gets calls in desktop breakpoint
     */
    onDesktop() {
        // implement by child
    }

    /**
     * Resize handler which get called when component resizes
     */
    onResize() {
        // implement by child
    }
}

export default Component;
